// extracted by mini-css-extract-plugin
module.exports = {"list":"q6srh","title":"_52YOD","container":"ciUqX","center":"fS7Jl","item":"WrMwB","hide_tabletLarge":"M8vu3","show_tabletLarge":"vHEsY"};